import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var StateLink = props => ___EmotionJSX("a", {
  onClick: () => {
    props.onStateSelect(props.text);
  },
  href: props.browseUrlFormat.replace('%state', props.href),
  className: props.className
}, props.text);
StateLink.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  browseUrlFormat: PropTypes.string.isRequired,
  onStateSelect: PropTypes.func
};
StateLink.defaultProps = {
  className: null,
  onStateSelect: () => {}
};
export default StateLink;